<div class="login-page">
    <div class="login-bg-img">
        <img src="./assets/images/login-bg-img.webp" alt="">
    </div>


    <div class="container">
        <div class="login-container">
            <div class="welcome">
                <!-- <h2>Forgot Password</h2> -->
                <p>Please enter your email to reset your password.</p>
            </div>
            <form class="">
                <h4>Forgot Password</h4>
                <input pInputText name="email" [(ngModel)]="email" placeholder="Enter your email" />
                <button pButton label="Submit" (click)="onSubmit()" [disabled]="!email"></button>
            </form>
        </div>
    </div>
    <p-toast></p-toast>